module.exports = __webpack_public_path__ + "img/qrcode1.cb55a6cb.png";